export const COUNTRY_OPTIONS = [
  {
    value: 'Australia',
    label: 'Australia',
  },
  {
    value: 'Canada',
    label: 'Canada',
  },
  {
    value: 'Europe',
    label: 'Europe',
  },
  {
    value: 'United Kingdom',
    label: 'United Kingdom',
  },
  {
    value: 'United States',
    label: 'United States',
  },
];
export const INTEND_OPTIONS = [
  {
    value: 'Children',
    label: 'Children',
  },
  {
    value: 'Adult',
    label: 'Adult',
  },
  {
    value: 'General Use',
    label: 'General Use',
  },
];
